module.exports = __webpack_public_path__ + "img/gradient-ball.a4df6619.png";